/*
  gmtCreatedTime：创建时间
  during：持续时间（当前时间-创建时间）
  单位（s）
*/

export function getFormateTime(gmtCreatedTime: Date, during: number) {
  if (during < 60) {
    return '刚刚'
  } else if (during < 3600) {
    return Math.floor(during / 60) + '分钟前'
  } else if (during < 86400) {
    return Math.floor(during / 3600) + '小时前'
  } else if (during < 172800) {
    return '一天前'
  } else {
    let Y = gmtCreatedTime.getFullYear()
    let M = gmtCreatedTime.getMonth() + 1
    let D = gmtCreatedTime.getDate()
    return Y + '-' + zeroize(M) + '-' + zeroize(D)
  }
}

function zeroize(num: number) {
  return (String(num).length == 1 ? '0' : '') + num
}
